import { readCookie } from '../../components/common/Cookie';
import { addCustomerType } from '../../utils/products';
import { storeNames } from '../constants/cart.constants';
import { catalogIdToStoreName } from '../../utils/catalogIdToStoreName';
import { appendItmSourceToURL } from '../../modules/ga/GTMdatalayer';

export const proceedToShipping = (cb: (arg0: string) => void): void => {
  const user = readCookie('U');
  if (user === 'anonymous') {
    sessionStorage.setItem('prevUrl', document.referrer);
    cb(`/login?referrer=${encodeURIComponent(appendItmSourceToURL('/cart'))}`);
  } else {
    cb(appendItmSourceToURL('/shipping'));
  }
};

export const redirect = (url = '') => (): void => {
  window.location.href = url;
};

export const getCartUrl = (appendItmSource = false): string => {
  const cartPath = addCustomerType('/cart');
  // Only bag CTAs (Add to Bag / Go to Bag) should carry itm_source.
  // Header / bottom-nav cart clicks stay as plain /cart.
  return appendItmSource ? appendItmSourceToURL(cartPath) : cartPath;
};

export const getDeliveryFeeTagInfo = (
  catalogName: string | undefined,
  storeWiseDeliveryFeeTags: {
    street?: Record<string, string>;
    ajiodeliveryfee?: Record<string, string>;
    ajiofreedelivery?: Record<string, string>;
    luxedeliveryfee?: Record<string, string>;
    luxefreedelivery?: Record<string, string>;
  },
  convenienceFee: { delivery: { netAmount: { value: string } } }
) => {
  const {
    street = {},
    ajiodeliveryfee = {},
    ajiofreedelivery = {},
    luxedeliveryfee = {},
    luxefreedelivery = {}
  } = storeWiseDeliveryFeeTags;
  const itemStoreName = catalogIdToStoreName(catalogName);
  const { AJIO_STORE, LUXE_STORE, STREET_STORE } = storeNames;
  const isDeliveryFeeApplicable = parseInt(convenienceFee?.delivery?.netAmount?.value) > 0;

  let deliveryFeeTag = '';
  let isItemWithFreeDelivery = false;
  if (itemStoreName == STREET_STORE) {
    deliveryFeeTag = street.flag == 'ON' ? street.title : '';
    isItemWithFreeDelivery = true;
  } else if (itemStoreName == AJIO_STORE) {
    deliveryFeeTag = isDeliveryFeeApplicable
      ? ajiodeliveryfee.flag == 'ON'
        ? ajiodeliveryfee.title
        : ''
      : ajiofreedelivery.flag == 'ON'
      ? ajiofreedelivery.title
      : '';
    isItemWithFreeDelivery = !isDeliveryFeeApplicable;
  } else if (itemStoreName == LUXE_STORE) {
    deliveryFeeTag = isDeliveryFeeApplicable
      ? luxedeliveryfee.flag == 'ON'
        ? luxedeliveryfee.title
        : ''
      : luxefreedelivery.flag == 'ON'
      ? luxefreedelivery.title
      : '';
    isItemWithFreeDelivery = !isDeliveryFeeApplicable;
  }

  return { deliveryFeeTag, isItemWithFreeDelivery };
};
